import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { Stack } from '@mui/material';

import { CustomAlert, CustomButton, Text } from '../../../shared/uiComponents';
import { errorNormalizer } from '../../../shared/Helpers/functions';
import { RED } from '../../../shared/Helpers/colors';
import { TrashEmpty } from '../../../shared/Assets/sessionDetailsSVGs';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { deleteUserSessionAllocation, getUserActiveAllocations } from '../../../redux/State/userSlice';

const DeleteAllocation = ({ onClose, allocationId, userId, disabled = false }: { allocationId: string | null; disabled?: boolean; onClose: () => void; userId?: string }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const [open, setOpen] = useState(false);

	const handleDelete = () => {
		if (!allocationId) return;
		dispatch(deleteUserSessionAllocation(allocationId))
			.then(unwrapResult)
			.then(() => {
				toast('Success');
				if (userId) dispatch(getUserActiveAllocations(userId));
				onClose();
			})
			.catch(errorNormalizer);
	};

	const isDeleting = useSelector((state) => state.userSessionAllocation.isDeleting);

	return (
		<>
			<CustomButton
				title="Delete allocation"
				onClick={() => setOpen(true)}
				buttonType="quaternary"
				disabled={disabled || isDeleting}
				style={{ color: RED.BASE }}
				startIcon={<TrashEmpty color={RED.BASE} />}
			/>
			<CustomAlert
				isBusy={isDeleting}
				open={open}
				onClose={() => setOpen(false)}
				title="Delete allocation?"
				Content={() => (
					<Stack spacing={3}>
						<Text title="This provider will no longer be able to log Admin Hours. Previously logged hours will be kept." type="psm" />
						<Stack direction="row" justifyContent="flex-end" alignItems="center" gap="12px" flexWrap="wrap" alignSelf="stretch">
							<CustomButton title="Cancel" buttonType="secondaryGray" onClick={() => setOpen(false)} disabled={isDeleting} />
							<CustomButton
								title="Delete allocation"
								onClick={handleDelete}
								buttonType="secondary"
								style={{ backgroundColor: RED.QUATERNARY, color: RED.BASE }}
								startIcon={<TrashEmpty color={RED.BASE} />}
								loading={isDeleting}
							/>
						</Stack>
					</Stack>
				)}
			/>
		</>
	);
};

export default DeleteAllocation;
